// @dynamic-i18n-keys
// Dynamic t() at lines 18, 34 (errorName from ErrorNames):
//   searchPage.emptyState.title.none
//   searchPage.emptyState.title.request
//   searchPage.emptyState.title.highOffset
//   searchPage.emptyState.title.noResults
//   searchPage.emptyState.title.pastEndOfResults
//   searchPage.emptyState.title.allMature
//   searchPage.emptyState.title.allStored
//   searchPage.emptyState.title.allDeleted
//   searchPage.emptyState.title.allAntisocial
//   searchPage.emptyState.title.highLoad
//   searchPage.emptyState.title.allBlocked
//   searchPage.emptyState.title.noDeviantsYouWatch
//   searchPage.emptyState.title.tagBlocked
//   searchPage.emptyState.title
//   searchPage.emptyState.suggestion.none
//   searchPage.emptyState.suggestion.request
//   searchPage.emptyState.suggestion.highOffset
//   searchPage.emptyState.suggestion.noResults
//   searchPage.emptyState.suggestion.pastEndOfResults
//   searchPage.emptyState.suggestion.allMature
//   searchPage.emptyState.suggestion.allStored
//   searchPage.emptyState.suggestion.allDeleted
//   searchPage.emptyState.suggestion.allAntisocial
//   searchPage.emptyState.suggestion.highLoad
//   searchPage.emptyState.suggestion.allBlocked
//   searchPage.emptyState.suggestion.noDeviantsYouWatch
//   searchPage.emptyState.suggestion.tagBlocked
//   searchPage.emptyState.suggestion
import type { FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { ErrorNames } from '../../../constants';
import EmptyResultError from './EmptyResultError';
import s from './EmptyResult.scss';

export interface Props {
  searchTerm?: string;
  errorName: ErrorNames;
}

const SearchEmptyResult: FC<Props> = ({ searchTerm, errorName }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(s['search'], s['empty-state-root'])}>
      <div className={s['empty-state-label']}>
        {t([`searchPage.emptyState.title.${errorName}`, 'searchPage.emptyState.title'], {
          searchTerm,
        })}
      </div>
      {errorName && (
        <div className={s['empty-state-error']}>
          <EmptyResultError errorName={errorName} />
        </div>
      )}
      <div className={s['empty-state-suggestion']}>
        {t([`searchPage.emptyState.suggestion.${errorName}`, 'searchPage.emptyState.suggestion'])}
      </div>
    </div>
  );
};
SearchEmptyResult.displayName = 'SearchEmptyResult';

export default SearchEmptyResult;
